import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "settings-list" }
const _hoisted_2 = { class: "bts-wrapper__top" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("delete")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Delete Selected", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("add")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Create", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("edit ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("delete ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "property-key" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" edit ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" delete ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_icon = _resolveComponent("ui-icon")!
  const _component_ui_fab = _resolveComponent("ui-fab")!
  const _component_ui_grid_cell = _resolveComponent("ui-grid-cell")!
  const _component_ui_tab = _resolveComponent("ui-tab")!
  const _component_ui_tabs = _resolveComponent("ui-tabs")!
  const _component_ui_pagination = _resolveComponent("ui-pagination")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_zero_state = _resolveComponent("zero-state")!
  const _component_ui_card_media = _resolveComponent("ui-card-media")!
  const _component_ui_grid = _resolveComponent("ui-grid")!
  const _component_ui_card = _resolveComponent("ui-card")!
  const _component_ui_panel = _resolveComponent("ui-panel")!
  const _component_visualisations = _resolveComponent("visualisations")!
  const _component_ui_panels = _resolveComponent("ui-panels")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ui_dialog_title = _resolveComponent("ui-dialog-title")!
  const _component_ui_dialog_content = _resolveComponent("ui-dialog-content")!
  const _component_ui_dialog_actions = _resolveComponent("ui-dialog-actions")!
  const _component_ui_dialog = _resolveComponent("ui-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_grid, { class: "container" }, {
      default: _withCtx(() => [
        (!_ctx.isSubRoute)
          ? (_openBlock(), _createBlock(_component_ui_grid_cell, {
              key: 0,
              class: "bts-wrapper",
              columns: "12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    (_ctx.lengthOf2D(_ctx.selectedRows) > 1)
                      ? (_openBlock(), _createBlock(_component_ui_fab, {
                          key: 0,
                          extended: "",
                          class: "btn-delete-all btn--inline",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDeleteSelectedRows()))
                        }, {
                          before: _withCtx(({ iconClass }) => [
                            _createVNode(_component_ui_icon, {
                              class: _normalizeClass(iconClass)
                            }, {
                              default: _withCtx(() => [
                                _hoisted_3
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ]),
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ui_fab, {
                      extended: "",
                      class: "btn-create-item btn--inline",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onModalOpen('Create')))
                    }, {
                      before: _withCtx(({ iconClass }) => [
                        _createVNode(_component_ui_icon, {
                          class: _normalizeClass(iconClass)
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      ]),
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.isSubRoute)
          ? (_openBlock(), _createBlock(_component_ui_grid_cell, {
              key: 1,
              columns: "12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_tabs, {
                  class: "tabs",
                  modelValue: _ctx.activeTab,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTabsLength, (n, i) => {
                      return (_openBlock(), _createBlock(_component_ui_tab, {
                        class: "tab",
                        key: i
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.getTabKey(i)), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ui_panels, {
                  modelValue: _ctx.activeTab,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeTab) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (value, name) => {
                      return (_openBlock(), _createBlock(_component_ui_panel, { key: name }, {
                        default: _withCtx(() => [
                          (Array.isArray(value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (value.length)
                                  ? (_openBlock(), _createBlock(_component_ui_table, {
                                      key: 0,
                                      class: "table",
                                      modelValue: _ctx.selectedRows[_ctx.activeTab],
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedRows[_ctx.activeTab]) = $event)),
                                      fullwidth: "",
                                      data: value,
                                      thead: _ctx.thead,
                                      tbody: _ctx.tbody,
                                      ref: `table-${name}`,
                                      "row-checkbox": "",
                                      "selected-key": "id",
                                      "data-table": `table-${name}`
                                    }, {
                                      actions: _withCtx(({ data }) => [
                                        _createVNode(_component_ui_icon, {
                                          class: "icon--hover",
                                          onClick: ($event: any) => (_ctx.editRow(data))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_8
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_ui_icon, {
                                          class: "icon--hover",
                                          onClick: ($event: any) => (_ctx.deleteRow(data))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_9
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_ui_pagination, {
                                          modelValue: _ctx.page,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
                                          total: value.length,
                                          "show-total": "",
                                          onChange: _ctx.onPage
                                        }, null, 8, ["modelValue", "total", "onChange"])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "data", "thead", "tbody", "data-table"]))
                                  : (_openBlock(), _createBlock(_component_ui_card, {
                                      key: 1,
                                      outlined: "",
                                      class: "card card--zero-state"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ui_grid, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ui_grid_cell, { columns: "12" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ui_card_media, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_zero_state)
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (pData, key, index) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                                    _createElementVNode("h5", _hoisted_11, _toDisplayString(key), 1),
                                    (pData.length)
                                      ? (_openBlock(), _createBlock(_component_ui_table, {
                                          key: 0,
                                          class: "table",
                                          modelValue: _ctx.selectedRows[index],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.selectedRows[index]) = $event),
                                          fullwidth: "",
                                          data: pData,
                                          thead: _ctx.thead,
                                          tbody: _ctx.tbody,
                                          ref: `table-${name}-${key}`,
                                          "data-table": `table-${name}-${key}`,
                                          "row-checkbox": "",
                                          "selected-key": "id"
                                        }, {
                                          actions: _withCtx(({ data }) => [
                                            _createVNode(_component_ui_icon, {
                                              class: "icon--hover",
                                              onClick: ($event: any) => (_ctx.editRow(data, key))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_12
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_ui_icon, {
                                              class: "icon--hover",
                                              onClick: ($event: any) => (_ctx.deleteRow(data, key))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_13
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_ui_pagination, {
                                              modelValue: _ctx.page[index],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.page[index]) = $event),
                                              total: pData.length,
                                              "show-total": "",
                                              onChange: _ctx.onPage
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "total", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "data", "thead", "tbody", "data-table"]))
                                      : (_openBlock(), _createBlock(_component_ui_card, {
                                          key: 1,
                                          outlined: "",
                                          class: "card card--zero-state"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ui_grid, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ui_grid_cell, { columns: "12" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ui_card_media, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_zero_state)
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                  ], 64))
                                }), 128))
                              ]))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_ui_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_visualisations)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ui_grid_cell, { columns: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_dialog, {
          modelValue: _ctx.open,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.open) = $event)),
          onConfirm: _ctx.onConfirm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ui_dialog_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.actionType), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ui_dialog_content, null, {
              default: _withCtx(() => [
                _createElementVNode("p", null, "Do you want " + _toDisplayString(_ctx.actionType.toLowerCase()) + " item?", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ui_dialog_actions)
          ]),
          _: 1
        }, 8, ["modelValue", "onConfirm"])
      ]),
      _: 1
    })
  ]))
}